import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { DbLeagueTeam } from '@par/shared/types/league';

type PropTypes = {
  close: () => void;
  onLeagueGameCreate: (
    leagueTeamsInPlay: string[],
    leagueSeason: number,
    leagueWeek: number,
    leagueGame: number
  ) => void;
  open: boolean;
  teams: DbLeagueTeam[];
};

export const CreateLeagueGameDialog = ({
  close,
  onLeagueGameCreate,
  open,
  teams,
}: PropTypes) => {
  const theme = useTheme();
  const [season, setSeason] = useState(0);
  const [week, setWeek] = useState(1);
  const [game, setGame] = useState(1);
  const [leagueQuestionCount, setLeagueQuestionCount] = useState(20);
  const [checkedTeams, setCheckedTeams] = useState<Record<string, boolean>>();

  useEffect(() => {
    if (!open) return;
    const checkedTeams = teams.reduce((a, c) => ((a[c._id] = false), a), {});
    setCheckedTeams(checkedTeams);
  }, [open]);

  const createTourneyGame = () => {
    const leagueTeamsInPlay = Object.keys(checkedTeams).filter(
      (teamId) => checkedTeams[teamId]
    );
    if (leagueTeamsInPlay.length !== 2) return;
    console.log('leagueTeamsInPlay', leagueTeamsInPlay);
    onLeagueGameCreate(leagueTeamsInPlay, season, week, game);
    close();
  };

  const handleSeasonChange = (event: SelectChangeEvent) => {
    setSeason(+event.target.value);
  };

  const handleWeekChange = (event: SelectChangeEvent) => {
    setWeek(+event.target.value);
  };

  const handleGameChange = (event: SelectChangeEvent) => {
    setGame(+event.target.value);
  };

  const handleLeagueQuestionCountChange = (event: SelectChangeEvent) => {
    setLeagueQuestionCount(+event.target.value);
  };

  const handleCheckPlayingTeam = (checked: boolean, teamId: string) => {
    const filtered = Object.values(checkedTeams).filter((checked) => checked);
    if (checked && filtered.length >= 2) return;
    setCheckedTeams((prev) => ({
      ...prev,
      [teamId]: checked,
    }));
  };

  return (
    <>
      <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Stack spacing={2}>
            <Typography variant="h4" textAlign={'center'}>
              Create League Game
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} padding={2}>
            <Stack direction="row" spacing={4}>
              <FormControl variant="standard" sx={{ minWidth: 100 }}>
                <InputLabel>Season</InputLabel>
                <Select value={season.toString()} onChange={handleSeasonChange}>
                  <MenuItem value={0}>Pilot</MenuItem>
                </Select>
              </FormControl>
              <FormControl variant="standard" sx={{ minWidth: 100 }}>
                <InputLabel>Week</InputLabel>
                <Select value={week.toString()} onChange={handleWeekChange}>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                </Select>
              </FormControl>
              <FormControl variant="standard" sx={{ minWidth: 100 }}>
                <InputLabel>Game</InputLabel>
                <Select value={game.toString()} onChange={handleGameChange}>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                </Select>
              </FormControl>
              {/* <FormControl variant="standard" sx={{ minWidth: 100 }}>
                <InputLabel>Question Count</InputLabel>
                <Select
                  value={leagueQuestionCount.toString()}
                  onChange={handleLeagueQuestionCountChange}
                >
                  <MenuItem value={20}>20</MenuItem>
                </Select>
              </FormControl> */}
            </Stack>

            <Paper sx={{ bgcolor: '#65304d4a' }}>
              {checkedTeams ? (
                <FormControl component="fieldset" sx={{ paddingLeft: 1 }}>
                  <FormGroup>
                    {teams.map((t) => (
                      <FormControlLabel
                        value="top"
                        control={
                          <Checkbox
                            checked={checkedTeams[t._id]}
                            onChange={(e) =>
                              handleCheckPlayingTeam(e.target.checked, t._id)
                            }
                            size="small"
                          />
                        }
                        label={t.teamName}
                        labelPlacement="end"
                        sx={{
                          paddingLeft: 1,
                        }}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              ) : null}
            </Paper>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={close} fullWidth>
            Cancel
          </Button>
          <Button variant="contained" onClick={createTourneyGame} fullWidth>
            Create Game
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
